import React from 'react';
import { ElfsightWidget } from 'react-elfsight-widget';

const ReviewWidget = () => {
  const widgetId = 'f4820360-cd19-4a6d-bb2b-4e05a4446473';

  return <ElfsightWidget widgetId={widgetId} style={{fontFamily: "Raleway, sans-serif", color: 'white'}} />;
};

export default ReviewWidget;